import type { ReactNode } from "react";

type ExpenseFormSectionProps = {
  title: string;
  children: ReactNode;
};

export function ExpenseFormSection({
  title,
  children,
}: ExpenseFormSectionProps) {
  return (
    <section className="space-y-3 rounded-lg border bg-muted/20 px-4 pt-4 pb-3">
      <h3 className="font-medium text-sm">{title}</h3>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
